import { Component, OnInit } from '@angular/core';
import { Dspace } from '../../models/dspace';
import { NbDialogRef } from '@nebular/theme';
import * as momentHijri from 'moment-hijri';
import { Router } from '@angular/router';


@Component({
  selector: 'app-dspace-details',
  templateUrl: './dspace-details.component.html',
  styleUrls: ['./dspace-details.component.scss'],
})
export class DspaceDetailsComponent implements OnInit {
  model = {} as Dspace;

  constructor(private diag: NbDialogRef<DspaceDetailsComponent>,
       private route : Router
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diag.close('false');
     });
  }

  close() {
    this.diag.close();
  }

   getHijriDate(date) {
      return momentHijri(date, 'YYYY-MM-DD').format('iYYYY/iM/iD');
    }
}
